import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import EventNoteSharpIcon from '@material-ui/icons/EventNoteSharp';
import Paper from '@material-ui/core/Paper';
import { eventTabsColor } from '../constants/colorsCustom';

const useStyles = (customSet) =>
  makeStyles((theme) => ({
    root: {
      display: 'flex',
      flex: 1,
      backgroundColor: eventTabsColor,
      height: theme.spacing(5), //10
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      border: 'none',
      outline: 'none',
      boxShadow: '0px 0px 0px 0px',
    },
    title: {
      color: '#fff',
      paddingLeft: theme.spacing(2),
      fontWeight: '500',
    },

    cardIcon: {
      width: theme.spacing(5), //3.5
      backgroundColor: customSet?.noBackgroundIcon ? eventTabsColor : '#00acc1', //'#52c433' //customSet?.noBackgroundIcon ? eventTabsColor :
      height: theme.spacing(5), //3.5
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // borderRadius: '8px',
      // marginLeft: '15px',
    },
    icon: {
      fill: '#fff',
      // backgroundColor: '#52c433',
      // width: '100%',
      // height: '100%',
      // borderRadius: '8px',
    },
  }));

const HeaderStrip = (props) => {
  const classes = useStyles({
    noBackgroundIcon: props.icon?.noBackgroundIcon,
  })();

  return (
    <Paper className={classes.root}>
      <div className={classes.cardIcon}>
        {props.icon?.icon ? (
          props.icon?.icon
        ) : (
          <EventNoteSharpIcon className={classes.icon} />
        )}
      </div>
      <Typography align="left" variant="body1" className={classes.title}>
        {props.title}
      </Typography>
    </Paper>
  );
};

export default HeaderStrip;
